module.exports = __webpack_public_path__ + "static/media/csv_up.886a1f56.svg";